import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
    useFetch,
    useForm,
    useGrid,
    useModal,
    useResource,
    useStore,
    useToast,
    usePage,
    useAuth,
    usePopup,
} from "@/comn/hooks";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { Page, Group, Layout, Button, FormControl } from "@/comn/components";
import {
    APIS,
    URLS,
    SF_USR_FRGNR_FORM,
    SG_VHCL_INFO_LIST,
    AddStr,
} from "@/tra/tancis/ptli/usr/frgnr/services/PtliUsrFrgnrService";

import { PTLI0919004S } from "@/tra/tancis/ptli/usr/frgnr/PTLI0919004S";
import { error } from "console";

/*
 * Foreign Transporter Registration
 * !== 외국인 운송업체 등록 ==!
 */
export const PTLI0919002S = (props: any) => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_cgmi0067", "auth_ptli0042", "auth_ptlianyADM"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const popup = usePopup(); // Popup Hook !== Popup Hook ==!
    const [cntyNm, setCntyNm] = useState(); // Company Process State Code !== 업체 프로세스 상태 코드 ==!

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "LCM0003" },
            { area: "comnCd", comnCd: "LCM0010" },
            { area: "cntyCd" },
        ],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Foreign Transporter Registration !== 외국인 운송업체 등록 Form ==!
        usrFrgnrForm: useForm({
            defaultSchema: SF_USR_FRGNR_FORM,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        saveFrgnr: useFetch({
            api: (data) => {
                return APIS.saveFrgnr(data);
            },
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.00003",
                    onConfirm: () => {
                        navigate(URLS.ptli0919001s);
                    },
                });
            },
            onError: (error) => {
                modal.openModal({
                    content: error.response.data.errorMessage,
                });
            },
        }),
        getPinDuplCheck: useFetch({
            api: (data) => {
                return APIS.getPinDuplCheck(data);
            },
            onSuccess: (data) => {
                const lcneYys = data.pinDuplCheck.content;
                if (!comnUtils.isEmpty(lcneYys)) {
                    if (lcneYys !== "N") {
                        const lcneYyArr = lcneYys.indexOf(",") > -1 ? String(lcneYys).split(",") : [lcneYys];
                        if (
                            lcneYyArr.some((lcneYy: any) => {
                                return lcneYy == form.usrFrgnrForm.getValue("lcneYy");
                            })
                        ) {
                            modal.openModal({ content: "msg.ptl.00812" }); // The license year selected as the PIN user is duplicated and cannot be subscribed. !== 해당 PIN 사용자로 선택한 라이선스 년도가 중복되어 가입이 불가능 합니다. ==!
                            return;
                        }
                    }
                } else {
                    modal.openModal({ content: "msg.ptl.00758" }); // Duplicate TIN. !== 이미 사용중인 TIN 번호입니다. ==!
                    return;
                }

                form.usrFrgnrForm.clearErrors("pin");
                const frgnrInfo = form.usrFrgnrForm.getValues();
                modal.openModal({
                    content: "msg.00101",
                    onConfirm: () => {
                        fetch.saveFrgnr.fetch(frgnrInfo);
                    },
                });
            },
            onError: (error) => {
                modal.openModal({
                    content: error.response.data.errorMessage,
                });
            },
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        saveFrgnr: form.usrFrgnrForm.handleSubmit(
            (data) => {
                fetch.getPinDuplCheck.fetch(data);
            },
            () => {
                toast.showToast({ type: "warning", content: "msg.00002" });
            },
        ),
    };

    const render = {};

    let [physPlotNm, physBlckNm, physStretNm] = form.usrFrgnrForm.watch(["physPlotNm", "physBlckNm", "physStretNm"]);
    let [postBoxNo, postRegnNm, postDstrNm] = form.usrFrgnrForm.watch(["postBoxNo", "postRegnNm", "postDstrNm"]);

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        form.usrFrgnrForm.setValue("physAddr", AddStr([physPlotNm, physBlckNm, physStretNm]));
        form.usrFrgnrForm.setValue("postAddr", AddStr([postBoxNo, postRegnNm, cntyNm]));
    }, [physPlotNm, physBlckNm, physStretNm, postBoxNo, postRegnNm, postDstrNm]);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Layout direction="col" gap={4}>
                        <Group.Section>
                            <Layout direction="col" gap={4}>
                                <Layout direction="col">
                                    <Layout>
                                        <Layout.Left>
                                            <Group.Title title={t("T_FRGNR_TRPR_INFO")} titleSize={2}></Group.Title>
                                        </Layout.Left>
                                    </Layout>

                                    <Group.Section>
                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrForm.schema.pin}></Group.Control>
                                            <Group.Cell size={6}>{t("msg.ptl.00803")}</Group.Cell>
                                        </Group.Row>

                                        <Group.Row>
                                            {/*<Group.Control {...form.usrFrgnrForm.schema.coTin}></Group.Control>*/}
                                            <Group.Control {...form.usrFrgnrForm.schema.cstmLcneNo}></Group.Control>
                                        </Group.Row>

                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrForm.schema.lcneYy}></Group.Control>
                                            <Group.Control {...form.usrFrgnrForm.schema.lcneVldtyDays}></Group.Control>
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrForm.schema.rgsrTrdrNm}></Group.Control>
                                            <Group.Control {...form.usrFrgnrForm.schema.bizTpCd}></Group.Control>
                                        </Group.Row>

                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrForm.schema.trprOwrsTrckNo}></Group.Control>
                                        </Group.Row>

                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrForm.schema.bizLcneNo}></Group.Control>
                                            <Group.Control {...form.usrFrgnrForm.schema.bizLcneIssDtm}></Group.Control>
                                        </Group.Row>

                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrForm.schema.preLcneNo}></Group.Control>
                                            <Group.Control {...form.usrFrgnrForm.schema.preLcneIssDtm}></Group.Control>
                                        </Group.Row>
                                    </Group.Section>
                                </Layout>
                            </Layout>
                        </Group.Section>

                        <Group.Section>
                            <Layout direction="col" gap={4}>
                                <Layout direction="col">
                                    <Layout>
                                        <Layout.Left>
                                            <Group.Title title={t("T_CTS")} titleSize={2}></Group.Title>
                                        </Layout.Left>
                                    </Layout>

                                    <Group.Section>
                                        <Group.Cell root>
                                            <Group.Cell header>{t("L_PHYS_ADDR")}</Group.Cell>
                                            <Group.Cell size={10}>
                                                <Group.Cell header size={2}>
                                                    {t("L_PLOT")}
                                                </Group.Cell>
                                                <Group.Cell size={8}>
                                                    <FormControl {...form.usrFrgnrForm.schema.physPlotNm} />
                                                </Group.Cell>

                                                <Group.Cell header size={2}>
                                                    {t("L_BLCK")}
                                                </Group.Cell>
                                                <Group.Cell size={8}>
                                                    <FormControl {...form.usrFrgnrForm.schema.physBlckNm} />
                                                </Group.Cell>

                                                <Group.Cell header size={2}>
                                                    {t("L_STRET")}
                                                </Group.Cell>
                                                <Group.Cell size={8}>
                                                    <FormControl {...form.usrFrgnrForm.schema.physStretNm} />
                                                </Group.Cell>

                                                <Group.Cell size={10}>
                                                    <FormControl {...form.usrFrgnrForm.schema.physAddr} />
                                                </Group.Cell>
                                            </Group.Cell>
                                        </Group.Cell>

                                        <Group.Cell root>
                                            <Group.Cell header>{t("L_POST_ADDR")}</Group.Cell>
                                            <Group.Cell size={10}>
                                                <Group.Cell header size={2}>
                                                    {t("L_BOX_NO")}
                                                </Group.Cell>
                                                <Group.Cell size={8}>
                                                    <FormControl {...form.usrFrgnrForm.schema.postBoxNo} />
                                                </Group.Cell>

                                                <Group.Cell header required size={2}>
                                                    {t("L_REGN")}
                                                </Group.Cell>
                                                <Group.Cell size={8}>
                                                    <FormControl {...form.usrFrgnrForm.schema.postRegnNm} />
                                                </Group.Cell>

                                                <Group.Cell header required size={2}>
                                                    {t("L_CNTY")}
                                                </Group.Cell>
                                                <Group.Cell size={8}>
                                                    <FormControl
                                                        {...form.usrFrgnrForm.schema.postDstrNm}
                                                        callback={(data) => setCntyNm(data.label)}
                                                    />
                                                </Group.Cell>

                                                <Group.Cell size={10}>
                                                    <FormControl {...form.usrFrgnrForm.schema.postAddr} />
                                                </Group.Cell>
                                            </Group.Cell>
                                        </Group.Cell>

                                        <Group.Cell root>
                                            <Group.Cell required header>
                                                {t("L_EML_ADDR")}
                                            </Group.Cell>
                                            <Group.Cell size={10}>
                                                <FormControl {...form.usrFrgnrForm.schema.emlAddr} />
                                            </Group.Cell>
                                        </Group.Cell>
                                    </Group.Section>
                                </Layout>
                            </Layout>
                        </Group.Section>
                    </Layout>
                </Group.Body>
            </Group>

            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.ptli0919001s);
                        }}
                    />
                </Layout.Left>
                <Layout.Right>
                    <Button
                        role="save"
                        onClick={() => {
                            handler.saveFrgnr();
                        }}
                    />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
